/* eslint-disable import/prefer-default-export */
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { UKFUNCTIONS, FUNCTIONS, AUFUNCTIONS } from '..';

function getFunctionsInstanceByRegion(region?: string) {
    switch (region) {
        case 'europe-west2':
            return UKFUNCTIONS;
        case 'australia-southeast1':
            return AUFUNCTIONS;
        case 'us-central1':
        default:
            return FUNCTIONS;
    }
}

export function callFunction<Request, Response>(
    functionName: string,
    request?: Request,
    region?: string,
) {
    const functions = getFunctionsInstanceByRegion(region);
    const callFunction = httpsCallable(functions, functionName);

    if (request == null) {
        return callFunction() as Promise<HttpsCallableResult<Response>>;
    }

    return callFunction(request) as Promise<HttpsCallableResult<Response>>;
}
